export default __webpack_public_path__ + "static/media/fluent_building-shop-16-regular.e886fbf0.svg";